jQuery(function($) {
  let $win = $(window),
    $doc = $(document),
    $body = $("body"),
    $h = $(".hero-banner--hidden")

  function home() {
    function initData() {
      let slogan = $h.find(".field--name-field-alumni-title p").html()
      let link = $h.find(".field--name-field-alumni-link a").attr("href")
      let body = $h.find(".field--name-body p").html()
      let mobileImg = $h
        .find(".field--name-field-mobile-image img")
        .attr("src")
      let mobileBody = $h
        .find(".field--name-field-homebanner-mobile-body .field__item")
        .text()

      $(".hero-banner--slogan")
        .html(slogan)
        .append(`<a href="${link}" class="hero-banner--more">More</a>`)
      $(".hero-banner--desc").html(body)

      $(".hero-banner-mobile--slogan").html(slogan)
      $(".hero-banner-mobile").css({
        "background-image": `url(${mobileImg})`
      })
      $(".hero-banner-mobile--desc").text(mobileBody)
    }

    function initVideo() {
      let video = $h.find(".field--name-field-video video source").attr("src")
      if (video) {
        $(`
      <video  autoplay loop>
        <source src="${video}" type="video/mp4">
          Your browser does not support the video tag.
      </video>
      `).appendTo(".hero-banner--video")

        return true
      } else {
        return false
      }
    }

    function initSlider() {
      let $slider = $(".hero-banner--slider")
      if ($slider.length) {
        $h.find(".field--name-field-image > .field__item img").each((k, v) => {
          let img = $(v).attr("src")
          $(`
        <div class="hero-banner--slide">
          <div class="hero-banner--slide-img" style="background-image: url(${img})"></div>
        </div>
        `).appendTo($slider)
        })
        $slider.slick({
          autoplay: true,
          autoplaySpeed: 5000,
          infinite: false,
          speed: 500,
          pauseOnFocus: false,
          pauseOnHover: false
        })
      }
    }

    function initCount() {
      $h
        .find(".field--name-field-alumni-l1-number > .field__item")
        .each((k, v) => {
          let $tar = $(".hero-banner--num").eq(k)

          let num = { val: 0 }
          let goal = parseInt(
            $(v)
              .find(".field--name-field-alumni-l1-int")
              .text()
          )
          let text = $(v)
            .find(".field--name-field-alumni-l1-suffix")
            .text()

          TweenLite.to(num, 5, {
            val: goal,
            roundProps: "val",
            onUpdate: () => {
              $tar
                .find("div")
                .text(
                  num.val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "+"
                )
            }
          })
          $tar.find("p").text(text)
        })
    }
    
    // banner mobile layout, click the 'scroll down' button triggers scroll
    function initBannerScroll() {
      let $eventBlk = $('#block-views-block-alumni-events-block-1')
      let $top = $('.top-bar')
      let $header = $('.header')
      $('.hero-banner-mobile--scroll').on('click', e => {
        TweenLite.to(window, .4, {
          scrollTo: $eventBlk.offset().top - $header.outerHeight(true) - $top.outerHeight(true)
        })
      })
    }
    
    // hide the 'upcoming events' & 'highlights block items' if no items
    function initBlocks() {
      $('.region-content .block-views').each((k,v) => {
        var $block = $(v)
        if ($block.find('.views-row').length === 0) {
          $block.hide()
        }
      })
    }
    

    initData()
    if (!bowser.mobile && !bowser.tablet) {
      initVideo() || initSlider()
    }
    initCount()
    initBannerScroll()
    initBlocks()
  }

  function webform() {
    let $left = $(".webform-left")
    let $right = $(".webform-right")
    let $title = $left.find("h2")
    let $form = $right.find("form")

    function breakTitle() {
      let t = $.trim($title.text())
      $title.html(t.split(" ").join("<br>"))
    }

    function moveDesc() {
      $right.find(".field--name-body").appendTo($left)
    }

    function formStyle() {
      $form
        .find("input, textarea")
        .on("focus", e => {
          $(e.target)
            .closest(".form-item")
            .addClass("active")
        })
        .on("blur", e => {
          $(e.target)
            .closest(".form-item")
            .removeClass("active")
        })
    }

    // breakTitle()
    moveDesc()
    formStyle()
  }
  
  function global() {
    // remove sns icons inner text
    $('i.fa').each((k,v) => {
      $(v).text('')
    })
  }

  global()
  if ($body.hasClass("path-frontpage")) home()
  if ($body.hasClass("page-node-type-webform")) webform()
})
